import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import AddLinkIcon from "@mui/icons-material/AddLink";
import AddIcon from "@material-ui/icons/Add";
import { Link } from "@mui/material";
import MaterialTable from "material-table";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Multiselect from "multiselect-react-dropdown";
// import Button from "@material-ui/core/Button";
import CloseIcon from "@mui/icons-material/Close";
import { Autocomplete } from "@mui/material";
import { ListItemIcon, ListItem, ListItemText } from "@material-ui/core";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import store from "../../../redux/store";
import PtsAlert from "../ptsAlert/PtsAlert";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import PtsButton from "../buttons/PtsButton";
import FetchServerData from "../../../provider/FetchServerData";
import {
  CreateShort_URL,
  DeleteShortLink_Url,
  GroupList_Url,
  ShortLinkList_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import UiUtils from "../../../provider/UiUtils";
import { BUSINESS_DOMAIN, MESSAGE_TYPES } from "../../../provider/Enums";
import DeleteButton from "../buttons/DeleteButton";

export default class MessageQuestion extends Component {
  header = store.getState().header.header;
  interactiveQuestionTypeList =
    store.getState().staticData.interactiveQuestionTypeList;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  accountSettings = store.getState().accountSetting?.accountSetting;
  pledgeDonationIntegration =
    store.getState().appUserData.appUserData.pledgeDonationIntegration;
  crmIntegration = store.getState().crmIntegration.crmIntegration;
  organization = store.getState().appUserData?.organizationDetails;
  constructor(props) {
    super(props);
    let action = props.action;
    let selectedGroups = [];
    for (let i = 0; i < props.data.selectedGroups?.length; i++) {
      const element = props.data.selectedGroups[i];
      selectedGroups.push(element?.smsGroup);
    }
    const type = props.data.questionType?.type;
    if (type === "SelectGroup") {
      this.getSelectGroupList(props.data.questionType, selectedGroups);
    } else if (type === "ConfirmGroup") {
      this.getConfirmGroupList(
        props.data.questionType,
        props.data?.groupToJoin
      );
    }

    this.state = {
      messageType: props.messageType,
      id: props.data.id,
      question: props.data.question !== "" ? props.data.question : "",
      questionType: props.data.questionType,
      selectedGroups: selectedGroups,
      smsVariableList: props.smsVariableList,
      operation: props.data.operation,
      index: props.srno,
      step: props.data.step,
      onDelete: props.onDelete,
      onChange: props.onChange,
      onSuccess: props.onSuccess,
      onPaymentLink: props.onPaymentLink,
      action: action,
      cursorPosition: 0,
      render: true,
      isDelete: false,
      copied: false,
      onQuestionItemAdd: props.onAdd,
      smsPledgeQuestion: [],
      groupToJoin: null,
      smsGroupList: [],
      shortLinkList: [],
      pageSize: 10,
      initialPage: 0,
      isPaging: false,
      alertVisible: false,
      isPaymentLink: false,
      discontinueText: props.data.discontinueText,
      hasMessageWithYesNoKeyword: props.hasMessageWithYesNoKeyword,
    };
  }

  getSelectGroupList(questiontype, selectedGroups) {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(GroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          this.props.onSuccess?.(questiontype, this.state.index);
          let selectedGroupsIds = [];
          for (let i = 0; i < selectedGroups?.length; i++) {
            selectedGroupsIds.push(selectedGroups[i]?.id);
          }
          let questionDescription =
            selectedGroups === undefined
              ? Utils.getSmsQuestionType(questiontype?.type, smsGroupList[0])
              : this.state.question;
          this.setState({
            smsGroupList: smsGroupList,
            selectedGroups: selectedGroups !== undefined ? selectedGroups : [],
            selectedGroupsIds: selectedGroupsIds,
            questionType: questiontype,
            question: questionDescription,
          });
        } else {
        }
      }
    );
  }
  getConfirmGroupList(questiontype, groupToJoinId) {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(GroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          this.props.onSuccess?.(questiontype, this.state.index);
          let groupToJoin =
            groupToJoinId !== undefined
              ? smsGroupList?.find((group) => group?.id === groupToJoinId)
              : Utils.getArrayElement(smsGroupList, 0);
          let questionDescription = Utils.getSmsQuestionType(
            questiontype?.type,
            groupToJoin?.name
          );
          this.setState({
            smsGroupList: smsGroupList,
            question: questionDescription,
            questionType: questiontype,
            groupToJoin: groupToJoin,
          });
        } else {
        }
      }
    );
  }

  deleteQuestionItem(e) {
    if (this.state.onDelete) {
      this.state.isDelete = true;
      this.state.onDelete(this.state, this.state.index);
    }
  }

  handleQuestionTextMessageChange(e) {
    let cursorPosition = e.target.selectionStart;
    let val = e.target.value;
    val = val?.replace(/—/g, "");
    let isPaymentLink = val?.includes("{{Payment Link}}");
    this.setState({ question: val, cursorPosition: cursorPosition, isPaymentLink: isPaymentLink, });
    this.props.onChange();
  }

  handleInsertItMessageChange = () => {
    const insertText = "Msg&data rates apply. STOP to quit. ";
    const { question = "", cursorPosition = question.length } = this.state;

    const newText =
      question.slice(0, cursorPosition) +
      insertText +
      question.slice(cursorPosition);

    this.setState({
      question: newText,
      cursorPosition: cursorPosition + insertText?.length,
    });
  };

  // handleQuestionInsert(selectedValue) {
  //   const shouldInsertSpace =
  //     this.state.cursorPosition > 0 &&
  //     this.state.question[this.state.cursorPosition - 1] !== " ";

  //   const newText =
  //     this.state.question.substring(0, this.state.cursorPosition) +
  //     (shouldInsertSpace ? " " : "") +
  //     selectedValue.value +
  //     this.state.question.substring(this.state.cursorPosition);
  //   this.props.onPaymentLink(selectedValue)
  //   this.setState(
  //     {
  //       question: newText,
  //       cursorPosition:
  //         this.state.cursorPosition +
  //         selectedValue.value.length +
  //         (shouldInsertSpace ? 1 : 0),
  //     },
  //     () => {
  //       // Ensure cursor is placed correctly
  //       const input = document.getElementById("messageBox");
  //       if (input) {
  //         input.focus();
  //         input.setSelectionRange(
  //           this.state.cursorPosition,
  //           this.state.cursorPosition
  //         );
  //       }
  //     }
  //   );
  //   // this.setState({
  //   //   question: `${this.state.question.substring(0, this.state.cursorPosition)} ${
  //   //     selectedValue.value
  //   //   } ${this.state.question.substring(this.state.cursorPosition)}`,
  //   // });
  // }


  handleCreateShortLinkInsert(selectedValue) {
    this.setState({
      question: `${this.state.question} ${selectedValue}`,
    });
  }

  handleQuestionInsert = (selectedValue) => {
    const isPaymentLink =
      selectedValue?.value?.includes("{{Payment Link}}");

    if (isPaymentLink && this.state.question.includes("{{Payment Link}}")) {
      return;
    }

    if (
      isPaymentLink &&
      Utils.equalsIgnoreCase(this.crmIntegration, "BlackBaudCRM")
    ) {
      this.props.onPaymentLink((value) => {
        this.insertQuestionText(value); // updates child state
      });
      return;
    }

    this.insertQuestionText(selectedValue.value);
  };

  insertQuestionText = (text, position) => {
    const { question } = this.state;

    const cursorPosition =
      position !== undefined ? position : this.state.cursorPosition;

    const shouldInsertSpace =
      cursorPosition > 0 && question[cursorPosition - 1] !== " ";

    const newText =
      question.substring(0, cursorPosition) +
      (shouldInsertSpace ? " " : "") +
      text +
      question.substring(cursorPosition);

    const newCursor =
      cursorPosition + text.length + (shouldInsertSpace ? 1 : 0);

    this.setState(
      {
        question: newText,
        cursorPosition: newCursor,
      },
      () => {
        const input = document.getElementById("messageBox");
        if (input) {
          input.focus();
          input.setSelectionRange(newCursor, newCursor);
        }
      }
    );
  };

  handleSMSQuestionTypeChange(selectedValue) {
    if (selectedValue?.type === "SelectGroup") {
      this.getSelectGroupList(selectedValue);
    } else if (selectedValue?.type === "ConfirmGroup") {
      this.getConfirmGroupList(selectedValue);
    } else {
      this.state.onSuccess(selectedValue, this.state.index);
      let questionDescription = Utils.getSmsQuestionType(
        selectedValue?.type,
        this.state.groupToJoin?.name
      );
      this.setState({
        questionType: selectedValue,
        question: questionDescription,
      });
    }
  }
  handleSMSGroupChange(selectedValue) {
    let questionDescription = Utils.getSmsQuestionType(
      this.state.questionType?.type,
      selectedValue?.name
    );
    this.setState({
      groupToJoin: selectedValue,
      question: questionDescription,
    });
  }
  addQuestionItem(e) {
    if (
      undefined !== this.state.onQuestionItemAdd &&
      null !== this.state.onQuestionItemAdd
    ) {
      this.state.onQuestionItemAdd(this.state);
    }
  }

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleAccountDropdownOpen = (e) => {
    this.getShortLinkList();
    this.setState({ open: true, anchorEl: e.currentTarget });
  };
  getShortLinkList() {
    const postObject = {
      header: this.header,
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(ShortLinkList_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let shortLinkList = output.data.shortLinkList;
          let isPaging = false;
          if (shortLinkList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < shortLinkList.length; i++) {
            shortLinkList[i].createdon = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(shortLinkList[i].createdon) : Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }
          this.setState({
            open: true,
            isPaging: isPaging,
            shortLinkList: shortLinkList,
          });
        } else {
        }
      }
    );
  }
  handleShortlinkUrlChange(e) {
    this.setState({
      shortlinkUrl: e.target.value,
    });
  }

  createShortlinkToBackend() {
    if (this.state.shortlinkUrl === "") {
      return PtsAlert.error("Please enter URL");
    }
    const postObject = {
      header: this.header,
      url: this.state.shortlinkUrl,
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(CreateShort_URL, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let shortUrl = output.data.shortUrl;
          this.setState({
            shortUrl: shortUrl,
          });
        } else {
        }
      }
    );
  }

  handleSmsVariableOnDrag(e) {
    e.preventDefault();
    let smsVariable = e.target.innerHTML;
    this.setState((prevState) => ({
      question: `${prevState.question.substring(
        0,
        this.state.cursorPosition
      )} ${smsVariable} ${prevState.question.substring(
        this.state.cursorPosition
      )}`,
      cursorPosition: `${prevState.question.substring(
        0,
        this.state.cursorPosition
      )} ${smsVariable} ${prevState.question.substring(
        this.state.cursorPosition
      )}`.length,
    }));
  }

  onSelectGroups(selectedList, selectedItem) {
    let selectedGroupsIds = [];
    for (let i = 0; i < selectedList.length; i++) {
      selectedGroupsIds.push(selectedList[i].id);
    }
    this.setState({
      selectedGroups: selectedList,
      selectedGroupsIds: selectedGroupsIds,
      question: `${this.state.question}\n${selectedItem?.name}`,
    });
  }
  onRemoveGroups(selectedList, selectedItem) {
    let deleteQuestion = this.state.question?.replace(selectedItem?.name, "");
    let selectedGroupsIds = [];
    for (let i = 0; i < selectedList.length; i++) {
      selectedGroupsIds.push(selectedList[i].id);
    }
    this.setState({
      selectedGroups: selectedList,
      selectedGroupsIds: selectedGroupsIds,
      question: deleteQuestion,
    });
  }

  handleYesToCountinueChange(e) {
    this.setState({ discontinueText: e.target.value });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  onCopy = (e) => {
    this.setState({ copied: true, alertVisible: true });
    setTimeout(() => {
      this.setState({ alertVisible: false });
    }, 1000);
  };

  adjustTextareaHeight = () => {
    if (this.textareaRef.current) {
      this.textareaRef.current.style.height = "auto"; // Reset height
      this.textareaRef.current.style.height =
        this.textareaRef.current.scrollHeight + "px"; // Set new height
    }
  };

  handleCopy = (copiedIndex) => {
    if (copiedIndex !== null) {
      this.setState({
        alertVisible: false,
        copiedIndex: copiedIndex,
      });
    } else {
      this.setState({
        alertVisible: true,
        copiedIndex: copiedIndex,
      });
    }

    setTimeout(() => {
      this.setState({ alertVisible: false, copiedIndex: null });
    }, 1000);
  };

  deleteShortLink(data) {
    const postObject = {
      header: this.header,
      shortLink: {
        id: data.id,
        eventId: this.businessDomainId,
      },
    };
    FetchServerData.callPostService(DeleteShortLink_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let shortLinkList = output.data.shortLinkList;
          let isPaging = false;
          if (shortLinkList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < shortLinkList.length; i++) {
            shortLinkList[i].createdon = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(shortLinkList[i].createdon) : Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }
          this.setState({
            open: true,
            isPaging: isPaging,
            shortLinkList: shortLinkList,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  render() {
    this.textareaRef = React.createRef();
    if (this.state.render === false) {
      return "";
    }

    if (this.state.action === "edit") {
      return this.editMessageQuestion();
    } else {
      return this.viewMessageQuestion();
    }
  }

  editMessageQuestion() {
    const hasPaymentLink = this.props.questionItems?.some(
      (item) =>
        item?.question?.includes("{{Payment Link}}") &&
        item.operation !== "Delete"
    );
    const currentQuestion =
      this.props.questionItems?.[this.props.iteamIndex];

    const currentHasPaymentLink =
      currentQuestion?.question?.includes("{{Payment Link}}");

    const smsQuestionTypefilteredList = this.interactiveQuestionTypeList.filter(
      (item) => {
        if (this.state.hasMessageWithYesNoKeyword && item.type === "YesToContinue") {
          return false;
        }
        if (
          Utils.equalsIgnoreCase(
            this.props.messageType?.type,
            MESSAGE_TYPES.interactivePledge
          )
        ) {
          return !["SelectGroup", "ConfirmGroup", "YesNo"].includes(item.type);
        }

        return item.type !== "Pledge";
      }
    );
    return (
      <>
        <div
          className="row mt-2"
          style={{
            background: this.state.rowBackgroundColor,
          }}
        >
          <div
            className="col-sm-1 align-self-center text-end"
          // style={{
          //   width: "110px",
          // }}
          >
            {this.props.iteamIndex !== 0 &&
              this.props.questionItems.length > 1 && (
                <i
                  class="fa-regular fa-trash-can"
                  aria-hidden="true"
                  style={{
                    borderRadius: "25%",
                    color: "#6A7B8E",
                    fontSize: "18px",
                    width: "30px",
                    minHeight: "30px",
                    padding: "3px",
                    alignContent: "center",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                  onClick={this.deleteQuestionItem.bind(this)}
                ></i>
              )}
          </div>
          <div className="col-sm-11">
            <div className="row d-flex p-0 ps-1">
              {/* <div className="col-md-12 text-end">
                <RemoveIconButton
                  onClick={this.deleteQuestionItem.bind(this)}
                />
                &nbsp;&nbsp;
                {this.props.iteamIndex ===
                  this.props.questionItems.length - 1 && (
                  <Button
                    // id="ptsHollowButton"
                    style={{
                      textTransform: "capitalize",
                      padding: "3px 10px",
                      background: "#224f77",
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                    className="btn btn-default "
                    startIcon={<AddIcon />}
                    onClick={this.addQuestionItem.bind(this)}
                  >
                    Insert Message
                  </Button>
                )}
                &nbsp;&nbsp;
              </div> */}

              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-7 align-self-end">
                    <label
                      htmlFor="exampleFormControlTextarea1"
                      className="form-label ms-2 mb-0"
                    >
                      {/* {this.state.questionType?.description} */}
                      Msg {this.state.step}
                    </label>
                  </div>
                  <div className="col-md-5 pe-0">
                    <Autocomplete
                      id="size-small-outlined"
                      size="small"
                      fullWidth
                      disableClearable
                      autoComplete="off"
                      options={smsQuestionTypefilteredList}
                      value={this.state.questionType}
                      getOptionLabel={(option) => option.description}
                      ListboxProps={{
                        sx: {
                          fontSize: 15,
                          "& .MuiAutocomplete-option": {
                            padding: "5px 15px",
                            fontSize: "15px",
                            alignItems: "flex-start",
                          }, // Reduce option padding
                          "& .MuiListItemText-root": { padding: 0, margin: 0 }, // Reduce ListItemText padding
                        },
                        style: {
                          maxHeight: "400px",
                          overflowY: "auto",
                        },
                      }}
                      renderOption={(props, option, state) => (
                        <ListItem {...props}>
                          <ListItemText primary={option.description} />
                          {option.description === "Pledge" && (
                            <ListItemIcon>
                              <i
                                className="fa fa-thermometer-three-quarters thermometer-icon"
                                aria-hidden="true"
                                style={{
                                  color: "#6a7b8e",
                                  fontSize: "1.5rem",
                                }}
                              ></i>
                            </ListItemIcon>
                          )}
                        </ListItem>
                      )}
                      defaultValue={this.state.questionType}
                      onChange={(event, value) => {
                        this.handleSMSQuestionTypeChange(value);
                      }}
                      inputprops={{ style: { textTransform: "capitalize" } }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Please Select"
                          variant="outlined"
                          size="small"
                          className="autoComplete"
                          // required
                          style={{ background: "#fff" }}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="row d-flex ms-2 mt-1 mb-2">
                  <div className="col-md-12 p-0">
                    <textarea
                      title=""
                      required
                      ref={this.textareaRef}
                      value={this.state.question}
                      onChange={this.handleQuestionTextMessageChange.bind(this)}
                      onBlur={this.handleQuestionTextMessageChange.bind(this)}
                      className="form-control"
                      id="messageBox"
                      rows="3"
                      style={{
                        overflow: "hidden",
                        resize: "vertical",
                      }}
                    />
                    {this.state.step === 1 && (
                      <span
                        className="ms-1"
                        style={{
                          fontSize: "11px",
                          color: "black",
                          fontWeight: "normal",
                        }}
                      >
                        Did you include opt-out language?{" "}
                        <span
                          className="anchortag"
                          onClick={this.handleInsertItMessageChange.bind(this)}
                        >
                          <u>Insert it.</u>
                        </span>
                      </span>
                    )}
                    <span
                      style={{
                        fontSize: "14px",
                        float: "right",
                      }}
                    >
                      {Utils.trimLetters(this.state.question)}/
                      {this.accountSettings?.textMessageLength}
                    </span>
                    <br></br>
                    {this.accountSettings?.textMessageLength <
                      Utils.countLetters(this.state.question) && (
                        <span
                          className="danger ms-1"
                          style={{ color: "red", fontSize: "14px" }}
                        >
                          Your message is limited to{" "}
                          {this.accountSettings?.textMessageLength} characters.
                        </span>
                      )}
                  </div>
                </div>
              </div>
              {!Utils.equalsIgnoreCase(
                this.state.questionType?.type,
                "SelectGroup"
              ) &&
                !Utils.equalsIgnoreCase(
                  this.state.questionType?.type,
                  "ConfirmGroup"
                ) && (
                  <div className="col-md-3 mt-4 ms-3">
                    <ul
                      className="p-0"
                      style={{ listStyle: "none", marginTop: "18px" }}
                    >
                      {this.state.smsVariableList?.map((data, index) => {
                        if (
                          data.name === "PaymentLink" &&
                          hasPaymentLink &&
                          !currentHasPaymentLink
                        ) {
                          return null;
                        }

                        return (
                          <>
                            {/* {(data.value !== "{{Payment Link}}" ||
                              this.pledgeDonationIntegration !== "None") && ( */}
                            {data?.name === "FirstName" ?
                              <Tooltip
                                title={`Alternate: ${this.organization?.firstNameAlternateValue !== null ? this.organization?.firstNameAlternateValue : ""}`}
                                arrow
                                classes={{ popper: "alternateCustom-tooltip" }}
                                placement="right"
                              >
                                <li
                                  className="d-flex mt-1 variableButton"
                                  onClick={this.handleQuestionInsert.bind(
                                    this,
                                    data
                                  )}
                                >
                                  {data.name === "FirstName" && (
                                    <IconButton className="pe-1">
                                      <ChatBubbleOutlineIcon
                                        // className="anchortag"
                                        style={{
                                          fontSize: "16px",
                                          width: "25px",
                                        }}
                                      />
                                    </IconButton>
                                  )}

                                  <span
                                    style={{ cursor: "pointer" }}
                                    key={index}
                                    draggable
                                  >
                                    {data.description}
                                  </span>
                                </li>
                              </Tooltip>
                              :
                              <li
                                className="d-flex mt-1 variableButton"
                                onClick={this.handleQuestionInsert.bind(
                                  this,
                                  data
                                )}
                              >
                                {data.name === "FirstName" && (
                                  <IconButton className="pe-1">
                                    <ChatBubbleOutlineIcon
                                      // className="anchortag"
                                      style={{
                                        fontSize: "16px",
                                        width: "25px",
                                      }}
                                    />
                                  </IconButton>
                                )}
                                {data.name === "EventName" && (
                                  <IconButton className="pe-1">
                                    <i
                                      class="fa fa-plus"
                                      aria-hidden="true"
                                      style={{
                                        fontSize: "16px",
                                        width: "25px",
                                      }}
                                    ></i>
                                  </IconButton>
                                )}
                                {(data.name === "PaymentLink") && (
                                  <IconButton className="pe-1">
                                    <i
                                      class="fa fa-usd"
                                      aria-hidden="true"
                                      style={{
                                        fontSize: "16px",
                                        width: "25px",
                                      }}
                                    ></i>
                                  </IconButton>
                                )}
                                <span
                                  style={{ cursor: "pointer" }}
                                  key={index}
                                  draggable
                                >
                                  {hasPaymentLink && this.state.isPaymentLink ? "Edit Payment Link" : data.description}
                                </span>
                              </li>
                            }
                            {/* )} */}
                          </>
                        );
                      })}
                      <li
                        className="mt-1 variableButton"
                        onClick={this.handleAccountDropdownOpen}
                      >
                        <Tooltip title="" aria-label="add">
                          <IconButton
                            className="pe-1"
                            style={{ height: "15px" }}
                          >
                            <AddLinkIcon
                              style={{
                                // color: "#337ab7",
                                fontWeight: "600",
                                fontSize: "20px",
                                width: "25px",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                        <span>Insert Short Link</span>
                      </li>
                    </ul>
                  </div>
                )}
              {Utils.equalsIgnoreCase(
                this.state.questionType?.type,
                "ConfirmGroup"
              ) && (
                  <div className="col-md-3 align-self-center mb-3 ms-3">
                    <label
                      htmlFor="exampleFormControlTextarea1"
                      className="MuiAutocomplete-label form-label ms-1"
                    >
                      Set to
                    </label>
                    <Autocomplete
                      id="size-small-outlined"
                      size="small"
                      fullWidth
                      disableClearable
                      autoComplete="off"
                      ListboxProps={{
                        className: "custom-listbox",
                      }}
                      options={this.state.smsGroupList}
                      value={this.state.groupToJoin}
                      getOptionLabel={(option) => option.name}
                      defaultValue={this.state.groupToJoin}
                      onChange={(event, value) => {
                        this.handleSMSGroupChange(value);
                      }}
                      inputprops={{ style: { textTransform: "capitalize" } }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Please Select"
                          variant="outlined"
                          size="small"
                          className="autoComplete"
                          style={{ background: "#fff" }}
                        />
                      )}
                    />
                  </div>
                )}
              {Utils.equalsIgnoreCase(
                this.state.questionType?.type,
                "SelectGroup"
              ) && (
                  <>
                    <div className="col-md-3 align-self-center mt-.searchWrapper ms-3">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className="form-label ms-1"
                      >
                        Select Group options for message
                      </label>
                      <Multiselect
                        onRemove={this.onRemoveGroups.bind(this)}
                        onSelect={this.onSelectGroups.bind(this)}
                        options={this.state.smsGroupList}
                        selectedValues={this.state.selectedGroups}
                        displayValue="name"
                        showCheckbox
                        placeholder={
                          this.state.selectedGroups?.length === 0
                            ? "None"
                            : this.state.selectedGroups?.length > 1
                              ? `${this.state.selectedGroups?.length} groups selected`
                              : `${this.state.selectedGroups?.length} group selected`
                        }
                        hideSelectedList={true}
                      />
                      <span style={{ fontSize: "11px", color: "#000" }}>
                        Note: To add a new group or edit a group name, go to
                        Groups.
                      </span>
                    </div>
                  </>
                )}

              <Dialog
                open={this.state.open}
                onClose={this.handleAccountDropdownClose.bind(this)}
                maxWidth="xl"
              >
                <DialogTitle id="scroll-dialog-title">
                  <span style={{ color: "#fff" }}>Create Short Link</span>
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={this.handleAccountDropdownClose.bind(this)}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: 4,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
                </IconButton>
                <DialogContent style={{ padding: "0px 24px 24px 24px" }}>
                  <div
                    md={12}
                    style={{
                      width: "800px",
                      color: "#000",
                      fontSize: "small",
                    }}
                  >
                    <div className="row mt-2">
                      <div className="col-md-6 mt-1" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-supplierType"
                        >
                          Paste your long link here then click the button.
                        </label>
                        <input
                          type="link"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.shortlinkUrl}
                          onChange={this.handleShortlinkUrlChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                      <div
                        className="col-md-3 align-self-center"
                        style={{ marginTop: "32px" }}
                      >
                        <PtsButton
                          btnName="Shorten"
                          onClick={this.createShortlinkToBackend.bind(this)}
                        />
                      </div>
                    </div>
                    {this.state.shortUrl && (
                      <div className="row mt-3">
                        <div className="col-md-5">
                          <span className="ms-2">
                            <a
                              href={this.state.shortUrl}
                              target="_blank"
                              className="anchortag mt-4"
                              style={{
                                width: "220px",
                                color: "#5faee3",
                              }}
                            >
                              {this.state.shortUrl}
                            </a>{" "}
                            &nbsp;
                            <Tooltip
                              title="Copy to clipboard"
                              aria-label="add"
                              classes={{ popper: "custom-tooltip" }}
                            >
                              <IconButton>
                                <CopyToClipboard
                                  text={this.state.shortUrl}
                                  onClick={this.onCopy}
                                >
                                  <FileCopyIcon
                                    style={{
                                      color: "gray",
                                      fontSize: "20px",
                                    }}
                                  />
                                </CopyToClipboard>
                              </IconButton>
                            </Tooltip>
                          </span>
                        </div>
                      </div>
                    )}
                    <div
                      className="shortLinkMenu mt-4"
                      style={{ width: "100%" }}
                    >
                      <MaterialTable
                        title="…or copy a link from the list here to use again."
                        icons={UiUtils.getMaterialTableIcons()}
                        localization={{
                          body: {
                            emptyDataSourceMessage: (
                              <h5 className="dataNotAvailable">
                                No data found.
                              </h5>
                            ),
                          },
                        }}
                        columns={[
                          {
                            title: "#",
                            render: (rowData) => rowData.tableData.id + 1,
                            width: "5%",
                            align: "left",
                            cellStyle: {
                              width: "4%",
                            },
                          },

                          {
                            title: "Short Link",
                            field: "targetLink",
                            render: (rowData) => {
                              return (
                                <>
                                  {/* <a
                                    href={rowData.targetLink}
                                    target="_blank"
                                    className="anchortag fw-bold"
                                  > */}
                                  {Utils.truncateString(rowData.targetLink, 40)}
                                  {/* </a> */}
                                </>
                              );
                            },
                            cellStyle: {
                              width: "25%",
                              textTransform: "lowercase",
                            },
                          },
                          {
                            title: "Actions",
                            render: (rowData) => {
                              return (
                                <>
                                  {/* <Tooltip title="Copy to clipboard" aria-label="add"> */}
                                  <IconButton className="p-0 me-2">
                                    <CopyToClipboard
                                      text={rowData.targetLink}
                                      onClick={this.onCopy}
                                    >
                                      <FileCopyIcon
                                        style={{
                                          color: "gray",
                                          fontSize: "20px",
                                        }}
                                        onClick={this.handleCopy.bind(
                                          this,
                                          rowData.tableData.id + 1
                                        )}
                                      />
                                    </CopyToClipboard>
                                  </IconButton>
                                  {/* </Tooltip> */}
                                  &nbsp;&nbsp;
                                  {this.state.copiedIndex ===
                                    rowData.tableData.id + 1 && (
                                      <span className="CopyToClipboard">
                                        Short link copied!
                                      </span>
                                    )}
                                  <DeleteButton
                                    title={rowData.sourceLink}
                                    domainObject={rowData.sourceLink}
                                    onClick={this.deleteShortLink.bind(
                                      this,
                                      rowData
                                    )}
                                  />
                                </>
                              );
                            },
                            cellStyle: {
                              width: "8%",
                              textTransform: "lowercase",
                            },
                          },
                          {
                            title: "Target Page",
                            // field: "sourceLink",
                            render: (rowData) => (
                              <a
                                href={rowData.sourceLink}
                                target="_blank"
                                className="anchortag"
                              >
                                {Utils.truncateString(rowData.sourceLink, 50)}
                              </a>
                            ),
                            cellStyle: {
                              width: "40%",
                            },
                          },
                        ]}
                        data={this.state.shortLinkList}
                        options={{
                          emptyRowsWhenPaging: false,
                          sorting: true,
                          search: false,
                          actionsColumnIndex: -1,
                          // initialPage: this.state.initialPage,
                          // pageSize: this.state.pageSize,
                          pageSizeOptions: Utils.materialTablePageSize(),
                          paging: false,
                          headerStyle: {
                            backgroundColor: "#37517e",
                            fontWeight: "bold",
                            color: "#ffff",
                            align: "left",
                          },
                        }}
                        onChangePage={(page, pageSize) => {
                          this.handleMaterialTablePageChange(page, pageSize);
                        }}
                        components={{
                          Container: (props) => (
                            <div
                              {...props}
                              style={{
                                maxHeight: "400px", // Set your desired height
                                overflowY: "auto",
                              }}
                            />
                          ),
                        }}
                      />
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
              {this.state.questionType?.type === "YesToContinue" && (
                <div className="row mb-3 ms-0">
                  <div className="col-md-6 ps-2 pe-0">
                    <label
                      htmlFor="exampleFormControlTextarea1"
                      className="form-label"
                    >
                      If user's reply indicates they don't want to continue,
                      send this message
                    </label>
                    <textarea
                      value={this.state.discontinueText}
                      onChange={this.handleYesToCountinueChange.bind(this)}
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      style={{
                        overflow: "hidden",
                        resize: "vertical",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="insertMessage"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Link
            className="anchortag"
            type="button"
            component="button"
            variant="body2"
            onClick={this.addQuestionItem.bind(this)}
            style={{ display: "flex", alignItems: "center" }}
          >
            <AddIcon style={{ fontSize: "20px", marginRight: "5px" }} /> Insert
            Message
          </Link>
          <hr
            style={{
              flexGrow: 1,
              marginLeft: "10px",
              borderTop: "1px solid black",
            }}
          />
        </div>
      </>
    );
  }

  viewMessageQuestion() {
    return (
      <>
        <tr
          style={{
            margin: "0",
          }}
        >
          <td
            style={{
              border: "0.5px solid #ece6e6",
              padding: "0.2em 0.5em",
              width: "5%",
              textAlign: "left",
            }}
          >
            <span style={{ float: "left" }}>{this.state.index}</span>
          </td>
          <td
            style={{
              border: "0.5px solid #ece6e6",
              padding: "0.2em 0.5em",
              width: "20%",
              textAlign: "left",
            }}
          >
            <span style={{ float: "left" }}>
              {this.state.questionType
                ? this.state.questionType?.description
                : ""}
            </span>
          </td>
          <td
            style={{
              border: "0.5px solid #ece6e6",
              padding: "0.2em 0.5em",
              width: "70%",
              textAlign: "left",
            }}
          >
            {this.state.question} <br />
            {this.state.discontinueText !== null
              ? "If No - " + this.state.discontinueText
              : ""}
          </td>
        </tr>
      </>
    );
  }
}
